import { createFileRoute } from "@tanstack/react-router";

import ReplacedProxyList from "./-components/ReplacedProxyList";

export const Route = createFileRoute("/_app/_dashboard/proxy/list/replaced")({
  component: ReplacedProxyList,
});
